// The homepage can open the same document directly in its print layout.
if (window.location.hash === '#print') {
    window.addEventListener('load', () => window.print(), { once: true });
}
